import { useEffect } from "react";
import { CONTACT } from "@/lib/contact";

// Injects Schema.org LocalBusiness JSON-LD for local SEO
export default function SchemaJSONLD() {
  useEffect(() => {
    const id = "gorillas-jsonld";
    if (document.getElementById(id)) return;

    const data = {
      "@context": "https://schema.org",
      "@type": ["LocalBusiness", "AutomotiveBusiness", "EmergencyService"],
      name: "GORILLAS REBOQUE",
      legalName: "GORILLAS REBOQUE",
      taxID: "30.668.330/0001-10",
      vatID: "30.668.330/0001-10",
      description:
        "Guincho e reboque 24 horas em Belém, Ananindeua, Marituba e toda a Região Metropolitana. Atendimento rápido para carros, motos, caminhões e transporte de veículos.",
      image: "https://gorillasreboque.com/logo.jpg",
      telephone: "+55" + CONTACT.phoneRaw.replace(/^55/, ""),
      email: CONTACT.email,
      priceRange: "$$",
      openingHours: "Mo-Su 00:00-23:59",
      areaServed: [
        { "@type": "City", name: "Belém" },
        { "@type": "City", name: "Ananindeua" },
        { "@type": "City", name: "Marituba" },
        { "@type": "City", name: "Benevides" },
        { "@type": "City", name: "Castanhal" },
        { "@type": "City", name: "Santa Izabel do Pará" },
      ],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Belém",
        addressRegion: "PA",
        addressCountry: "BR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: -1.4558,
        longitude: -48.5039,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "emergency",
          telephone: "+5591982736261",
          availableLanguage: ["Portuguese"],
          areaServed: "BR",
        },
      ],
      serviceType: [
        "Guincho para carros",
        "Guincho para motos",
        "Guincho para caminhões",
        "Transporte de veículos",
        "Reboque particular",
        "Atendimento em acidentes",
        "Pane mecânica",
        "Pane elétrica",
        "Remoção para oficinas",
        "Transporte intermunicipal",
        "Transporte interestadual",
      ],
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);
  return null;
}
